module.exports = __webpack_public_path__ + "img/1.b9b8d230.png";